(() => {
  function installMobileVideoSwipeFallback(doc, browserWindow) {
    if (!doc || !doc.addEventListener || browserWindow.__coMobileVideoSwipeFallback) return;
    browserWindow.__coMobileVideoSwipeFallback = true;

    let gesture;
    const reset = () => { gesture = undefined; };

    doc.addEventListener('touchstart', (event) => {
      if (!browserWindow.matchMedia || !browserWindow.matchMedia('(max-width: 767px)').matches || !event.touches || event.touches.length !== 1) {
        reset();
        return;
      }

      const target = event.target;
      const gallery = target && target.closest ? target.closest('[data-main-media]') : null;
      const slide = gallery ? gallery.querySelector('[data-main-slide].is-selected[data-media-type="video"]') : null;
      if (!slide || !slide.contains(target)) {
        reset();
        return;
      }

      const touch = event.touches[0];
      gesture = {
        gallery,
        mediaId: slide.getAttribute('data-media-id'),
        startX: touch.clientX,
        startY: touch.clientY,
        lastX: touch.clientX,
        lastY: touch.clientY,
        horizontal: false,
      };
    }, { capture: true, passive: true });

    doc.addEventListener('touchmove', (event) => {
      if (!gesture || !event.touches || event.touches.length !== 1) return;
      gesture.lastX = event.touches[0].clientX;
      gesture.lastY = event.touches[0].clientY;
      const deltaX = gesture.lastX - gesture.startX;
      const deltaY = gesture.lastY - gesture.startY;
      if (Math.abs(deltaX) >= 12 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
        gesture.horizontal = true;
        if (event.cancelable) event.preventDefault();
      }
    }, { capture: true, passive: false });

    doc.addEventListener('touchend', (event) => {
      if (!gesture) return;
      const completed = gesture;
      reset();

      const touch = event.changedTouches && event.changedTouches[0];
      const endX = touch ? touch.clientX : completed.lastX;
      const endY = touch ? touch.clientY : completed.lastY;
      const deltaX = endX - completed.startX;
      const deltaY = endY - completed.startY;
      if (!completed.horizontal || Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;

      if (event.cancelable) event.preventDefault();
      browserWindow.setTimeout(() => {
        const selected = completed.gallery.querySelector('[data-main-slide].is-selected[data-media-type="video"]');
        if (!selected || selected.getAttribute('data-media-id') !== completed.mediaId) return;

        const direction = deltaX < 0 ? 'next' : 'previous';
        const button = completed.gallery.querySelector(`.flickityt4s-button.${direction}`);
        if (button) button.click();
      }, 0);
    }, { capture: true, passive: false });

    doc.addEventListener('touchcancel', reset, { capture: true, passive: true });
  }

  installMobileVideoSwipeFallback(document, window);
})();
